import * as React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import Legend from '../Legend';
import Drawing from './Drawing';
import Track from '../../common-components/Track';

interface IMapProps {}

const MapContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
`;

const MapOuterContainer = styled.div`
  width: 1414px;
  height: 930px;
  display: inline-block;
`;

const StyledLegend = styled(Legend)`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  font-size: 11px;
`;

const Map: React.FunctionComponent<IMapProps> = (props) => {
  const drawings = useSelector((state: any) => state.executor.drawingsOnMap);
  const tracks = useSelector((state: any) => state.executor.tracks);
  return (
    <MapOuterContainer>
      <MapContainer>
        <StyledLegend />
        {drawings.map((drawing: any, index: number) => (
          <Drawing key={index} points={drawing.points} type={drawing.type} />
        ))}
        {tracks.map((track: any, index: number) => (
          <Track key={index} {...track} />
        ))}
        <img src={require('../../../assets/images/map.png')} />
      </MapContainer>
    </MapOuterContainer>
  );
};

export default Map;
